import Phaser from 'phaser';
import { BootScene } from '@/scenes/BootScene';
import { TitleScene } from '@/scenes/TitleScene';
import { CharSelectScene } from '@/scenes/CharSelectScene';
import { IntroCutsceneScene } from '@/scenes/IntroCutsceneScene';
import { StageScene } from '@/scenes/StageScene';
import { HudScene } from '@/scenes/HudScene';
import { PauseScene } from '@/scenes/PauseScene';
import { OptionsScene } from '@/scenes/OptionsScene';
import { EndCutsceneScene } from '@/scenes/EndCutsceneScene';
import { ResultsScene } from '@/scenes/ResultsScene';
import { CreditsScene } from '@/scenes/CreditsScene';
import { DealScene } from '@/scenes/DealScene';
import { EndingsGalleryScene } from '@/scenes/EndingsGalleryScene';
import { FinaleChapterSelectScene } from '@/scenes/FinaleChapterSelectScene';
import { GameState } from '@/state/GameState';

/**
 * MANOR — entry point.
 *
 * Game canvas pinned at 1280×720 (16:9) for SoR-style framing.
 * Scenes proceed Boot → Title → (future: CharSelect → Stage → Results).
 *
 * Pixel-art = Phaser.Scale.NONE + integer-multiple scaling once art lands.
 * For scaffold, use FIT so it adapts to dev/preview windows of any size.
 */
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  width: 1280,
  height: 720,
  backgroundColor: '#0b0e14',
  pixelArt: true,
  antialias: false,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    TitleScene,
    CharSelectScene,
    IntroCutsceneScene,
    StageScene,
    HudScene,
    PauseScene,
    OptionsScene,
    EndCutsceneScene,
    ResultsScene,
    CreditsScene,
    DealScene,
    EndingsGalleryScene,
    FinaleChapterSelectScene,
  ],
};

const game = new Phaser.Game(config);

if (new URLSearchParams(window.location.search).has('stress')) {
  (window as unknown as { __MANOR_GAME__?: Phaser.Game }).__MANOR_GAME__ = game;
  // Stress-only: expose the GameState singleton so headless harnesses can set up
  // specific scenarios (e.g. jump to the Stage-9 finale gauntlet) without an
  // 8-stage playthrough. Never present in production (requires the ?stress flag).
  (window as unknown as { __MANOR_STATE__?: typeof GameState }).__MANOR_STATE__ = GameState;
}
